var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.39 15.54L13.61 12.51L15.8 15.54L19.7 10.23L17.78 8.82L15.8 11.49L13.58 8.46L11.39 11.49L9.17 8.46L5.3 13.77L7.22 15.18L9.17 12.51L11.39 15.54ZM12.5 24C10.84 24 9.28 23.6848 7.82 23.0544C6.36 22.4248 5.09 21.57 4.01 20.49C2.93 19.41 2.0752 18.14 1.4456 16.68C0.8152 15.22 0.5 13.66 0.5 12C0.5 10.34 0.8152 8.78 1.4456 7.32C2.0752 5.86 2.93 4.59 4.01 3.51C5.09 2.43 6.36 1.5748 7.82 0.9444C9.28 0.3148 10.84 0 12.5 0C14.16 0 15.72 0.3148 17.18 0.9444C18.64 1.5748 19.91 2.43 20.99 3.51C22.07 4.59 22.9248 5.86 23.5544 7.32C24.1848 8.78 24.5 10.34 24.5 12C24.5 13.66 24.1848 15.22 23.5544 16.68C22.9248 18.14 22.07 19.41 20.99 20.49C19.91 21.57 18.64 22.4248 17.18 23.0544C15.72 23.6848 14.16 24 12.5 24ZM12.5 21.6C15.18 21.6 17.45 20.67 19.31 18.81C21.17 16.95 22.1 14.68 22.1 12C22.1 9.32 21.17 7.05 19.31 5.19C17.45 3.33 15.18 2.4 12.5 2.4C9.82 2.4 7.55 3.33 5.69 5.19C3.83 7.05 2.9 9.32 2.9 12C2.9 14.68 3.83 16.95 5.69 18.81C7.55 20.67 9.82 21.6 12.5 21.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.1d2a1884746213152554368cca3b1470.svg";
export { ForwardRef as ReactComponent };